export const SKEYS = {
  AUTH: 'bbw_auth',
  SELECT_ACCOUNT_ID: 'bbw_select_account_id',
  SELECTED_LICENSORS: 'bbw_selected_licensors',
  LICENSEE: 'bbw_licensee',
  LICENSOR: 'bbw_licensor',
  IS_LICENSOR: 'bbw_is_licensor',
  BBW_USER_ID: 'bbw_userid',
  BBW_CURRENT_ACCOUNT_ID: 'bbw_current_account_id', // Get from localStore
  BBW_ACCOUNTDATA: 'bbw_accountdata',
  BBW_ALL_ACCOUNTSDATA: 'bbw_accountsdata',
  BBW_USER_CONTEXT: 'bbw_user_context',
  LISTEN_NOTIFICATION_FROM: 'bbw_listen_notification_from',
  BBW_ACCOUNT_COOKIE: 'bbw_account_cookie',
  USER_ID: 'bbw_userid',
  USER_DATA: 'bbw_userdata',
  BBW_ACCOUNT_ID: 'bbw_account_id', // Get from cookie after logout timeout
  BBW_ORDERS_PAGE_SELECTED_ACCOUNTS: 'bbw_orderspage_selectedaccounts',
  BBW_ORDERS_DASHBOARD_PAGE_CUSTOM_COLUMNS: 'bbw_orders_dashboard_page_custom_colunms',
  BBW_ARCHIVED_ORDERS_DASHBOARD_PAGE_CUSTOM_COLUMNS: 'bbw_archived_orders_dashboard_page_custom_colunms',
  BBW_ORDER_DASHBOARD_PAGE_CUSTOM_COLUMNS: 'bbw_order_dashboard_page_custom_colunms',
  BBW_ORDERS_PAGE_CUSTOM_INNER_COLUMNS: 'bbw_orderspage_custominnercolunms',
  BBW_ORDERS_DASHBOARD_QUICK_FILTERS: 'bbw_orders_dashboard_quick_filters',
  BBW_ARCHIVED_ORDERS_DASHBOARD_QUICK_FILTERS: 'bbw_archived_orders_dashboard_quick_filters',
  BBW_ORDERS_DASHBOARD_FILTERS_STATE: 'bbw_orders_dashboard_filters_state',
  BBW_ARCHIVED_ORDERS_DASHBOARD_FILTERS_STATE: 'bbw_archived_orders_dashboard_filters_state',
  BBW_ORDER_PAGE_FILTERS_STATE: 'bbw_order_page_custom_filters_state',
  FIRST_INIT_APP: 'first_init_app',
  BBW_ORDERS_ROUTING_CUSTOM_COLUMNS: 'bbw_orders_routing_custom_columns',
  BBW_ARCHIVED_ORDERS_ROUTING_CUSTOM_COLUMNS: 'bbw_archived_orders_routing_custom_columns',
  BBW_ORDERS_ROUTING_INFO_CUSTOM_COLUMNS: 'bbw_orders_routing_info_custom_columns',
  BBW_ORDERS_ROUTING_FILTERS_STATE: 'bbw_orders_routing_filters_state',
  BBW_ARCHIVED_ORDERS_ROUTING_FILTERS_STATE: 'bbw_archived_orders_routing_filters_state',
  BBW_ORDER_ROUTING_INFO_FILTERS_STATE: 'bbw_order_routing_info_custom_filters_state',
  BBW_ORDERS_ROUTING_QUICK_FILTERS: 'bbw_orders_routing_quick_filters',
  BBW_ARCHIVED_ORDERS_ROUTING_QUICK_FILTERS: 'bbw_archived_orders_routing_quick_filters',
  BBW_BRANDBOW_API_VERSION: 'brandbow_api_version'
};

export const NOT_CLEANABLE_SKEYS = [
  SKEYS.BBW_ORDERS_DASHBOARD_FILTERS_STATE,
  SKEYS.BBW_ARCHIVED_ORDERS_DASHBOARD_FILTERS_STATE,
  SKEYS.BBW_ORDERS_DASHBOARD_PAGE_CUSTOM_COLUMNS,
  SKEYS.BBW_ARCHIVED_ORDERS_DASHBOARD_PAGE_CUSTOM_COLUMNS,
  SKEYS.BBW_ORDERS_DASHBOARD_QUICK_FILTERS,
  SKEYS.BBW_ARCHIVED_ORDERS_DASHBOARD_QUICK_FILTERS,
  SKEYS.BBW_ORDER_PAGE_FILTERS_STATE,
  SKEYS.BBW_ORDER_DASHBOARD_PAGE_CUSTOM_COLUMNS,
  SKEYS.BBW_ORDERS_ROUTING_CUSTOM_COLUMNS,
  SKEYS.BBW_ORDERS_ROUTING_INFO_CUSTOM_COLUMNS,
  SKEYS.BBW_ORDERS_ROUTING_FILTERS_STATE,
  SKEYS.BBW_ORDER_ROUTING_INFO_FILTERS_STATE,
  SKEYS.BBW_ORDERS_ROUTING_QUICK_FILTERS,
];
